import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import {AnimationEvent, state, style, animate, transition, trigger} from '@angular/animations';
import {ToasterService, Toast} from '../toaster-service/toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./toaster.component.css'],
  animations: [
    trigger('openClose', [
        state('open', style({
          'max-height': '300px',
        })),
        state('closed', style({
          'max-height': '0px',
        })),
        transition('open => closed',
          [
            animate('0.5s ease-out'),
          ]),
      transition('* => open',
        [
          animate('0.5s ease-in'),
        ]),
      ],
    )],
})
export class ToasterComponent {
  isOpen = false;
  timeOutInMillis: number | undefined = 1;
  messageType = 'success';
  messageContent: string = '';
  hasCloseButton: boolean = false;
  centered: boolean = false;
  index = 0;
  parent: this | undefined;
  // @ts-ignore
  timeOut;

  constructor(private changeRef: ChangeDetectorRef) {
  }

  public fillToaster(toast: Toast) {
    this.messageContent = toast.toastMessage;
    this.timeOutInMillis = toast.timeOut;
    // @ts-ignore
    this.determineMessageTypeAndStyle(toast.type);
    this.hasCloseButton = toast.hasCloseButton;
    this.isOpen = true;
    this.changeRef.detectChanges();
  }

  private determineMessageTypeAndStyle(type: string) {
    if (type === 'wide-error') {
      this.messageType = 'error';
      this.centered = true;
      // @ts-ignore
      this.parent.styleEmitter.emit('centered');
    } else {
      this.messageType = type;
    }
  }

  onDismissListener() {
    this.closeToaster();
  }

  onAnimationEvent(event: AnimationEvent) {
    if (event.fromState === 'void' && event.toState === 'open' && event.phaseName === 'done') {
      this.changeRef.detectChanges();
      this.startTimer();
    }
    if (event.fromState === 'open' && event.toState === 'closed' && event.phaseName === 'done') {
      // @ts-ignore
      this.parent.removeToaster(this);
    }
  }

  startTimer() {
    if (this.timeOutInMillis === Infinity) {
      return;
    }
    this.timeOut = setTimeout(() => {
      this.closeToaster();
      // @ts-ignore
    }, this.timeOutInMillis * 1000);
  }

  public closeToaster() {
    this.isOpen = false;
    this.changeRef.detectChanges();
  }

  onClick() {
    if (this.messageType === 'success' && this.isOpen) {
      this.closeToaster();
    }
  }

  ngOnDestroy() {
    clearTimeout(this.timeOut);
  }

}
